import { render, staticRenderFns } from "./NewEditorModal.vue?vue&type=template&id=1c9574fd&scoped=true"
import script from "./NewEditorModal.vue?vue&type=script&lang=js"
export * from "./NewEditorModal.vue?vue&type=script&lang=js"
import style0 from "./NewEditorModal.vue?vue&type=style&index=0&id=1c9574fd&prod&lang=css"
import style1 from "./NewEditorModal.vue?vue&type=style&index=1&id=1c9574fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9574fd",
  null
  
)

export default component.exports